import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NzTagModule } from 'ng-zorro-antd/tag';

export type TagColorType = 'success' | 'warning' | 'error' | 'processing' | 'blue';

@Component({
  selector: 'ui-tag',
  templateUrl: './tag.component.html',
  styleUrl: './tag.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NzTagModule],
})
export class UITag {
  @Input() color?: TagColorType | string;
}
